export type DisclosureVariant = 'region' | 'inline-clamp';

export type DisclosureTriggerPosition = 'above' | 'below';

/**
 * Affordance drawn at the end of the trigger. `plus-minus` suits a stacked list such as an
 * accordion, where the rows already carry dividers and a rotating chevron reads as decoration.
 */
export type DisclosureTriggerIcon = 'chevron' | 'plus-minus' | 'none';

export const DISCLOSURE_HEADING_LEVELS = [2, 3, 4, 5, 6] as const;

/**
 * Heading level wrapped around the trigger. Levels start at 2 because a
 * disclosure sits inside a page that already owns its `h1`.
 */
export type DisclosureHeadingLevel = (typeof DISCLOSURE_HEADING_LEVELS)[number];

/** Context handed to a `triggerContent` template. */
export type DisclosureTriggerContext = {
    $implicit: boolean;
    expanded: boolean;
};
